module.exports = __webpack_public_path__ + "img/arrow-top-blue.27149f35.svg";